import type { InsertPoentialHighQuality } from '@here/api'
import { createResource, createSignal } from 'solid-js'
import { createPotentialHighQualityPost } from './resource'

export function usePotentialHighQuality() {
	const [createPotentialHighQuality, setCreatePotentialHighQuality] =
		createSignal<InsertPoentialHighQuality>()
	const [createPotentialHighQualityResource] = createResource(
		createPotentialHighQuality,
		createPotentialHighQualityPost,
	)

	return {
		createPotentialHighQualityResource,
		setCreatePotentialHighQuality,
	}
}
